import { type ColumnDefinition, ModelColumns } from '~/types/components';
import type { EmailTemplate } from '~/types/models';

export const Columns: Array<ColumnDefinition<EmailTemplate>> = [
  {
    title: 'Nom',
    key: 'name',
    sortable: true,
    type: 'string',
  },
  {
    title: 'Corps du message',
    key: 'body',
    only: ['single'],
    sortable: false,
    type: 'string',
  },
  ...ModelColumns,
];
